// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__H5eBj","image":"Header_image__2-dn2","name":"Header_name__3nxw-","info":"Header_info__2VsTY","infoRow":"Header_infoRow__1ZHg6"};